import { ShowWithComedian, getPrimaryShowComedian } from "@/data/shows";

import { Comedian } from "@/data/comedians";

export const NO_LINEUP_TITLE = "Lineup to be announced";

const hasRealShowTitle = (title: string | null | undefined): title is string =>
  Boolean(title && title.trim() !== "" && title !== "null");

const normalizeTitle = (title: string): string =>
  title.trim().replace(/\s+/g, " ").toLowerCase();

// An untitled show has nothing marking it as part of a series, so it keys alone
const lineupPlaceholderId = (show: ShowWithComedian): string =>
  hasRealShowTitle(show.title)
    ? `no-lineup:${show.venue_id}:${normalizeTitle(show.title)}`
    : `no-lineup:${show.id}`;

const lineupPlaceholderImage = (show: ShowWithComedian): string | null =>
  show.poster_img ||
  show.venue_pages.find((venuePage) => venuePage.logo_img)?.logo_img ||
  null;

// Unverified and slug-less, so the row renders the name as plain text with no
// follow affordance
const lineupPlaceholderComedian = (show: ShowWithComedian): Comedian => {
  const displayName = hasRealShowTitle(show.title)
    ? show.title
    : NO_LINEUP_TITLE;
  return {
    id: lineupPlaceholderId(show),
    display_name: displayName,
    display_name_short: displayName,
    slug: "",
    about_img: lineupPlaceholderImage(show),
    is_punchup_verified: false,
    is_external_preview: false,
    published_at: null,
  } as Comedian;
};

/**
 * The comedian a nearby row is headed by: the lineup's first, else a stand-in
 * built from the show itself, keyed so a recurring lineup-less series (same
 * venue, same title) groups into one row.
 */
export const showRowComedian = (show: ShowWithComedian): Comedian =>
  getPrimaryShowComedian(show) ?? lineupPlaceholderComedian(show);
